import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import {
  companyIdAtom,
  companyNameAtom,
  emailAtom,
  hasActiveAdminAtom,
  userFirstNameAtom,
  userLastNameAtom,
} from '../state/atoms';

export type UserStatus = {
  email: string;
  user: { fname: string; lname: string } | null;
  hasActiveAdmin: boolean;
  companyId: string | null;
  companyName: string | null;
};

// Stores a user status lookup in the registration atoms
export const useSetUserStatus = () => {
  const setEmail = useSetAtom(emailAtom);
  const setUserFirstName = useSetAtom(userFirstNameAtom);
  const setUserLastName = useSetAtom(userLastNameAtom);
  const setHasActiveAdmin = useSetAtom(hasActiveAdminAtom);
  const setCompanyId = useSetAtom(companyIdAtom);
  const setCompanyName = useSetAtom(companyNameAtom);

  return useCallback(
    (status: UserStatus) => {
      setEmail(status.email);
      setUserFirstName(status.user?.fname ?? null);
      setUserLastName(status.user?.lname ?? null);
      setHasActiveAdmin(status.hasActiveAdmin);
      setCompanyId(status.companyId);
      setCompanyName(status.companyName);
    },
    [
      setEmail,
      setUserFirstName,
      setUserLastName,
      setHasActiveAdmin,
      setCompanyId,
      setCompanyName,
    ]
  );
};
